import UnifiedDashboardContainer from "./UnifiedDashboardContainer";
import UnifiedDashboardStore from "./UnifiedDashboardStore";

export default UnifiedDashboardStore(UnifiedDashboardContainer);
